module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_japanese_map-d03e40207a279d3cdc131240daa4980e.svg";